/* eslint-disable camelcase -- api response is coming in snackcase */

import { Base64 } from 'js-base64';
import {
  actions,
  connectApiFetchOptions,
  getUrlQueryParams,
  postInstantMembershipMessage,
  apiLogSplunkEvent,
  sleep,
  PAYPAL_ERROR_CODES,
  UI_FLOWS,
  SPLUNK_EVENT_STATUS,
  SPLUNK_EVENT_NAME,
  ICN_EVENT_NAME,
  ICN_EVENT_STATUS,
} from '@americanexpress/amex-connect-core';
import { fromJS } from 'immutable';

export const apiCardOnFile = async ({
  authCode, correlationId, token, getState,
}) => {
  const state = getState();
  const options = connectApiFetchOptions({ apiName: 'cardonfile', credentials: 'same-origin' }, state, correlationId);
  options.init.method = 'post';
  options.init.body = JSON.stringify({ partner_auth_code: authCode });
  options.init.headers.Authorization = token;

  const event = {
    eventName: ICN_EVENT_NAME,
    eventStatus: ICN_EVENT_STATUS.FAILURE,
  };
  const logData = {
    payload: {
      api: 'cardonfile',
    },
  };
  try {
    const response = await fetch(options.url, options.init);
    const data = await response.json();
    logData.payload.response = data;

    const { status_code, panda_risk_score } = data;
    if (panda_risk_score === 'G') {
      event.eventStatus = ICN_EVENT_STATUS.SUCCESS;
    } else if (panda_risk_score === 'R') {
      event.eventStatus = ICN_EVENT_STATUS.CALL_CCP;
    }

    if (PAYPAL_ERROR_CODES.indexOf(status_code) !== -1) {
      event.eventMessage = `FAILURE FROM PAYPAL - debugId:${correlationId}`;
    } else if (event.eventStatus !== ICN_EVENT_STATUS.SUCCESS) {
      event.eventMessage = `FAILURE FROM CONNECT - debugId:${correlationId}`;
    }
  } catch (e) {
    logData.payload.errorMessage = e.message;
    event.eventMessage = `FAILURE FROM CONNECT - debugId:${correlationId}`;
  }

  if (event.eventStatus !== ICN_EVENT_STATUS.SUCCESS) {
    logData.eventStatus = SPLUNK_EVENT_STATUS.FAIL;
    logData.eventName = SPLUNK_EVENT_NAME.ICN_COF_FAILURES;
    await apiLogSplunkEvent(logData)(null, getState);
  }
  return event;
};

export const apiLinkStatusCardOnFile = async ({
  linkStatus, correlationId, token, getState, partner,
}) => {
  const state = getState();
  const options = connectApiFetchOptions({ apiName: 'cardonfile', credentials: 'same-origin' }, state, correlationId);
  options.init.method = 'post';
  options.init.body = JSON.stringify({ status: linkStatus === 'success' ? '00' : '01' });
  options.init.headers.Authorization = token;

  const event = {
    eventName: ICN_EVENT_NAME,
    eventStatus: ICN_EVENT_STATUS.FAILURE,
  };
  const logData = {
    payload: {
      api: 'cardonfile',
    },
  };
  try {
    const response = await fetch(options.url, options.init);
    const data = await response.json();
    logData.payload.response = data;

    if (data.status_code === '0000') {
      if (linkStatus === 'success') {
        event.eventStatus = ICN_EVENT_STATUS.SUCCESS;
      } else {
        event.eventMessage = `FAILURE FROM ${partner} - debugId:${correlationId}`;
      }
    } else {
      event.eventMessage = `FAILURE FROM CONNECT - debugId:${correlationId}`;
    }
  } catch (e) {
    logData.payload.errorMessage = e.message;
    event.eventMessage = `FAILURE FROM CONNECT - debugId:${correlationId}`;
  }

  if (event.eventStatus !== ICN_EVENT_STATUS.SUCCESS) {
    logData.eventStatus = SPLUNK_EVENT_STATUS.FAIL;
    logData.eventName = SPLUNK_EVENT_NAME.ICN_COF_FAILURES;
    await apiLogSplunkEvent(logData)(null, getState);
  }
  return event;
};

export const apiValidateUrl = async ({ correlationId, token, getState }) => {
  const state = getState();
  const options = connectApiFetchOptions({ apiName: 'validateurl', credentials: 'same-origin' }, state, correlationId);
  options.init.method = 'get';
  options.init.headers.Authorization = token;

  const event = {
    eventName: ICN_EVENT_NAME,
    eventMessage: `FAILURE FROM CONNECT - debugId:${correlationId}`,
  };
  const logData = {
    payload: {
      api: 'validateurl',
    },
  };

  try {
    const response = await fetch(options.url, options.init);
    const data = await response.json();
    logData.payload.response = data;

    const { status_code } = data;
    if (response.ok && status_code === '0000') {
      event.eventStatus = ICN_EVENT_STATUS.SUCCESS;
    } else {
      event.eventStatus = ICN_EVENT_STATUS.FAILURE;
    }
  } catch (e) {
    event.eventStatus = ICN_EVENT_STATUS.FAILURE;
    logData.payload.errorMessage = e.message;
  }

  if (event.eventStatus === ICN_EVENT_STATUS.FAILURE) {
    logData.eventStatus = SPLUNK_EVENT_STATUS.FAIL;
    logData.eventName = SPLUNK_EVENT_NAME.ICN_COF_FAILURES;
    await apiLogSplunkEvent(logData)(null, getState);
  }

  return event;
};

const processTermsAndCondition = async (partner, dispatch, getState) => {
  const {
    card_des, card_art_url, token, track_id, isTestPage,
  } = getUrlQueryParams(window.location.search);

  const card_info = Base64.decode(card_des);
  const split = card_info.split('&');
  const lastFive = split[1];
  const cardType = split[0];
  const isMissingFields = !(card_art_url && lastFive && cardType);

  const accounts = [{
    cardArtUri: Base64.decode(card_art_url),
    cardType,
    lastFive,
    accountNumber: lastFive,
  }];

  let event = { eventStatus: ICN_EVENT_STATUS.SUCCESS };
  if (!isMissingFields) {
    if (partner === 'AMAZON') {
      dispatch(actions.mergeValues(fromJS({
        partner,
        source: 'ICN',
        isLoading: true,
      })));

      event = await apiValidateUrl({ correlationId: track_id, token, getState });
      if (event.eventStatus === ICN_EVENT_STATUS.FAILURE) {
        const instantMembershipUrl = getState().getIn(['config', 'instantMembershipUrl']);
        postInstantMembershipMessage(JSON.stringify(event), instantMembershipUrl, isTestPage === 'true');
      }
    }
    if (event.eventStatus === ICN_EVENT_STATUS.SUCCESS) {
      localStorage.setItem(track_id, JSON.stringify({ token, isTestPage, accounts }));
      localStorage.setItem('icn_cid', track_id);

      dispatch(actions.mergeValues(fromJS({
        partner,
        accounts,
        isInstant: true,
        token,
        isLoading: false,
        splunkToken: token,
        isAccountsLoaded: true,
        source: 'ICN',
        correlationId: track_id,
        isTestPage: isTestPage === 'true',
      })));
    }
  } else {
    dispatch(actions.mergeValues(fromJS({
      partner,
      source: 'ICN',
      splunkToken: token,
      correlationId: track_id,
      isMissingFields,
    })));

    const logData = {
      eventStatus: SPLUNK_EVENT_STATUS.FAIL,
      eventName: SPLUNK_EVENT_NAME.ICN_COF_MISSING_FIELDS,
    };
    await apiLogSplunkEvent(logData)(dispatch, getState);

    event = {
      eventName: ICN_EVENT_NAME,
      eventStatus: ICN_EVENT_STATUS.FAILURE,
      eventMessage: `FAILURE FROM CONNECT - debugId:${track_id}`,
    };
    const instantMembershipUrl = getState().getIn(['config', 'instantMembershipUrl']);
    postInstantMembershipMessage(JSON.stringify(event), instantMembershipUrl, isTestPage === 'true');
  }
};

const getStateVariables = (state, separator) => {
  const variables = {};
  if (state) {
    const keyValuePairs = state.split(separator);
    keyValuePairs.forEach((keyValue) => {
      const [key, value] = keyValue.split('=');
      variables[key] = value;
    });
  }
  return variables;
};

const processCardOnFile = async (partner, dispatch, getState) => {
  const { code, state } = getUrlQueryParams(window.location.search);
  const { source, correlationId } = getStateVariables(state, ':');

  if (code && correlationId && source === 'ICN') {
    const icnData = JSON.parse(localStorage.getItem(correlationId));
    dispatch(actions.mergeValues(fromJS({
      partner,
      source,
      accounts: icnData.accounts,
      isInstant: true,
      isLoading: false,
      isAccountsLoaded: true,
      isCardOnFileStarted: true,
      selectedAccount: icnData.accounts[0].accountNumber,
      splunkToken: icnData.token,
      correlationId,
      isAccountFixed: true,
      currentFlow: UI_FLOWS.SCAN,
      isTestPage: icnData.isTestPage === 'true',
    })));

    await sleep(700); // wait for the on enter animation to complete
    const event = await apiCardOnFile({
      authCode: code, correlationId, token: icnData.token, getState,
    });
    localStorage.removeItem(correlationId);
    localStorage.removeItem('icn_cid');

    dispatch(actions.mergeValues(fromJS({
      isCardOnFileStarted: false,
      instantMembershipResult: event,
    })));
  }
};

const processLinkStatusCardOnFile = async (partner, dispatch, getState) => {
  const { linkstatus, state } = getUrlQueryParams(window.location.search);
  const { provisioningId } = state ? getStateVariables(Base64.decode(state), '&') : {};

  const instantMembershipUrl = getState().getIn(['config', 'instantMembershipUrl']);
  const icnData = JSON.parse(localStorage.getItem(provisioningId));

  if (linkstatus && provisioningId) {
    dispatch(actions.mergeValues(fromJS({
      partner,
      source: 'ICN',
      isInstant: false,
      isLoading: true,
      isAccountsLoaded: false,
      splunkToken: icnData.token,
      correlationId: provisioningId,
      isTestPage: icnData.isTestPage === 'true',
    })));

    const event = await apiLinkStatusCardOnFile({
      linkStatus: linkstatus,
      correlationId: provisioningId,
      token: icnData.token,
      getState,
      partner,
    });
    localStorage.removeItem(provisioningId);
    localStorage.removeItem('icn_cid');

    postInstantMembershipMessage(JSON.stringify(event), instantMembershipUrl, icnData.isTestPage === 'true');
  } else if (provisioningId) {
    dispatch(actions.mergeValues(fromJS({
      partner,
      source: 'ICN',
      splunkToken: icnData.token,
      correlationId: provisioningId,
    })));

    const logData = {
      eventStatus: SPLUNK_EVENT_STATUS.SUCCESS,
      eventName: SPLUNK_EVENT_NAME.ICN_COF_PARTNER_CANCEL,
    };
    await apiLogSplunkEvent(logData)(dispatch, getState);

    localStorage.removeItem(provisioningId);
    localStorage.removeItem('icn_cid');

    const event = {
      eventName: ICN_EVENT_NAME,
      eventStatus: ICN_EVENT_STATUS.CANCEL,
    };
    postInstantMembershipMessage(JSON.stringify(event), instantMembershipUrl, icnData ? icnData.isTestPage === 'true' : false);
  }
};

const processPartnerError = async ({
  partner, error, dispatch, getState,
}) => {
  const { state, error_description, debugid } = getUrlQueryParams(window.location.search);
  const { source, correlationId } = getStateVariables(state, ':');
  const cid = correlationId || localStorage.getItem('icn_cid');
  const icnData = JSON.parse(localStorage.getItem(cid));

  dispatch(actions.mergeValues(fromJS({
    partner,
    source: source || 'ICN',
    splunkToken: icnData.token,
    correlationId: cid,
    isTestPage: icnData.isTestPage === 'true',
  })));

  const logData = {
    eventStatus: SPLUNK_EVENT_STATUS.FAIL,
    eventName: SPLUNK_EVENT_NAME.ICN_COF_FAILURES,
    payload: { error, error_description, debugid },
  };
  await apiLogSplunkEvent(logData)(dispatch, getState);

  localStorage.removeItem(cid);
  localStorage.removeItem('icn_cid');

  const event = {
    eventName: ICN_EVENT_NAME,
    eventStatus: ICN_EVENT_STATUS.FAILURE,
    eventMessage: `FAILURE FROM PAYPAL - debugId:${debugid || cid}`,
  };
  const instantMembershipUrl = getState().getIn(['config', 'instantMembershipUrl']);
  postInstantMembershipMessage(JSON.stringify(event), instantMembershipUrl, icnData.isTestPage === 'true');
};

export const initiateInstantMembership = (partner) => async (dispatch, getState) => {
  const { token, track_id } = getUrlQueryParams(window.location.search);
  if (token && track_id) {
    await processTermsAndCondition(partner, dispatch, getState);
  } else {
    const { error } = getUrlQueryParams(window.location.search);
    if (error) {
      // errors that happen after user is redirected to partner's login page
      await processPartnerError({
        partner, error, dispatch, getState,
      });
    } else if (partner === 'AMAZON') {
      await processLinkStatusCardOnFile(partner, dispatch, getState);
    } else {
      await processCardOnFile(partner, dispatch, getState);
    }
  }
};
/* eslint-enable camelcase -- enabling camelcase */
